define(['santa-components', 'lodash', 'componentsCore', 'coreUtils', 'socialCommon', 'vKShareButton/aspect/vkPostMessageAspect'], function (santaComponents, _, componentsCore, coreUtils, socialCommon) {
    'use strict';

    const getIframeSrc = function (props, currentUrl) {
        const data = props.compData;
        const iframeParams = {
            id: props.id,
            url: currentUrl,
            style: data.style,
            text: data.text || 'Share'
        };

        return `${props.santaBase}/static/external/VKShare.html?${coreUtils.urlUtils.toQueryString(iframeParams)}`;
    };

    function getIframeProperties(props, size, currentUrl) {
        const a11yTitle = 'VK Share';

        return {
            allowtransparency: 'true',
            key: `VKShareButton-${props.currentUrlPageId}`,
            frameBorder: '0',
            'data-src': getIframeSrc(props, currentUrl),
            scrolling: 'no',
            style: _.clone(size),
            title: a11yTitle,
            'aria-label': a11yTitle
        };
    }

    return {
        displayName: 'VKShareButton',
        mixins: [componentsCore.mixins.skinBasedComp, socialCommon.socialCompMixin],
        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            santaBase: santaComponents.santaTypesDefinitions.santaBase.isRequired,
            currentUrlPageId: santaComponents.santaTypesDefinitions.currentUrlPageId.isRequired,
            size: santaComponents.santaTypesDefinitions.VK.size.isRequired
        },
        getRootStyle() {
            return _.pick(this.props.size, ['width', 'height']);
        },

        getSkinProperties() {
            const currentUrl = this.getSocialUrl();
            const iframeProps = getIframeProperties(this.props, this.props.size, currentUrl);//we need to create React.DOM.iframe so that we can pass it a key, to solve CLNT-4186
            const a11yTitle = 'VK Share';

            return {
                '': {
                    style: _.clone(this.props.size),
                    tabIndex: 0,
                    title: a11yTitle,
                    'aria-label': a11yTitle,
                    'data-src': iframeProps['data-src'],
                    tagName: 'wix-iframe'
                },
                iframe: santaComponents.utils.createReactElement('iframe', iframeProps)
            };
        }
    };
});
